module.exports = __webpack_public_path__ + "static/media/poster10.7458c383.png";